<template>
    <v-dialog max-width="500px" v-model="inDialog" @click:outside="onClickOutside" persistent>
        <v-card>
            <v-form ref="viewPresentForm">
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px">{{
                            $t(formCreateName)
                        }}</v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                        @click="onCancel"
                        icon
                        style="position: absolute; right: 10px; top: 10px; color: #fff"
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>

                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-text-field
                                type="text"
                                :label="$t('Tên địa điểm')"
                                v-model.trim="item.categoryName"
                                name="categoryName"
                                v-validate="'required'"
                                maxLength="250"
                                :error-messages="errors.first('categoryName')"
                                :data-vv-as="$t('Tên địa điểm')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-select
                                :items="lstStatus"
                                :label="$t('Trạng thái')"
                                v-model="item.status"
                                name="status"
                                item-value="value"
                                item-text="text"
                                v-validate="'required'"
                                :data-vv-as="$t('Trạng thái')"
                                :error-messages="errors.first('status')"
                            />
                        </v-flex>
                        <v-flex xs12>
                            <v-select
                                :items="pondAreas"
                                :label="$t('Khu nuôi')"
                                v-model="item.parentId"
                                name="parentId"
                                item-value="categoryId"
                                item-text="categoryCode"
                                :data-vv-as="$t('Khu nuôi')"
                                v-validate="'required'"
                                :error-messages="errors.first('parentId')"
                                
                            />
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <!-- </v-container> -->
            </v-form>
            <div style="text-align: right">
                <v-btn color="primary" @click="onSave">
                    <v-icon dark left>save</v-icon>
                    {{ $t("lang.common.save") }}
                </v-btn>
                <v-btn color="error" @click="onCancel">
                    <v-icon dark left>cancel</v-icon>
                    {{ $t("lang.common.cancel") }}
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { message } from "../../../services";
import axios from "axios";
import { cateContants } from "@/constants";

export default {
    name: "office-location-create",
    components: { message, axios },
    props: {
        propsItem: {
            type: Object,
            default: () => {
                return {}
            }
        },
        cDialog: {
            type: Boolean,
            default: false,
        },
        pondAreas: {
            type: Array,
            default: [],
        },
        formCreateName: {
            type: String,
            default: '',
        },
    },
    data: () => {
        return {
            lstStatus: cateContants.materialStatus,
            item: {
                categoryName: "",
                categoryTypeCode: "OFFICE_LOCATION",
                status: 1,
                parentId: '',
            },
            inDialog: false,
        };
    },
    watch: {
        propsItem: {
            handler(value) {
                //console.log(value);
                if (value !== null) {
                    this.item = {
                        categoryId: value.categoryId,
                        categoryName: value.categoryName ? value.categoryName : "",
                        status: value.status ? value.status : 0,
                        parentId: value.parentId ? value.parentId : 0,
                    };
                } else {
                    this.resetFrom();
                }
            },
            deep: true,
        },
        cDialog(value) {
            this.inDialog = value;
        },
        inDialog (value) {
            if(!value){
                this.$emit("closeCreateDialog", "");
            }
        },
    },
    methods: {
        resetFrom: function () {
            this.item = {
                categoryName: "",
                categoryTypeCode: "OFFICE_LOCATION",
                status: 1,
                parentId: '',
            };
        },
        onCancel: function () {
            this.$emit("closeCreateDialog", "");
        },
        onSave: function () {
            this.$validator.validate().then((valid) => {
                if (!valid) {
                    message.error(this.$t("lang.common.validate_fail"));
                    return;
                }
                axios
                    .post(
                        process.env.VUE_APP_API_URL +
                            "/category/save?categoryTypeCode=OFFICE_LOCATION",
                        this.item
                    )
                    .then(
                        (data) => {
                            if (data.success) {
                                message.success(
                                    this.$t("lang.common.save_success")
                                );
                                this.resetFrom();
                                this.onCancel();
                            } else {
                                let msg = data.description;
                                if (data.description === 'lang.category.duplicateName') {
                                    msg = 'lang.officeLocation.duplicateName';
                                }
                                message.error(this.$t(msg));
                            }
                        },
                        (error) => {
                            console.log(error);
                        }
                    );
            });
        },
        onClickOutside : function () {
            alert(1);
        },
    },
    created() {},
};
</script>
